import React from "react";
var __jsx = React.createElement;
import { memo, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import ZoneIndicator from "./ZoneIndicator";
import ScanFlowLayout from "./ScanFlowLayout";
import { getMediastinalContentForPointPhase, getMediastinalPointLabel, getMediastinalSlidesConfig } from "./config/mediastinalStepContent";
var MediastinalProtocol = /*#__PURE__*/memo(function (_ref) {
  var _currentPoint$point;
  var points = _ref.points,
    currentPointIndex = _ref.currentPointIndex,
    currentPhase = _ref.currentPhase,
    _ref$isLastPointSkipp = _ref.isLastPointSkipped,
    isLastPointSkipped = _ref$isLastPointSkipp === void 0 ? false : _ref$isLastPointSkipp,
    _ref$isTransitioning = _ref.isTransitioning,
    isTransitioning = _ref$isTransitioning === void 0 ? false : _ref$isTransitioning,
    onNext = _ref.onNext,
    onSkip = _ref.onSkip,
    onComplete = _ref.onComplete,
    onJumpToPoint = _ref.onJumpToPoint,
    onClose = _ref.onClose,
    menuItems = _ref.menuItems,
    activeMenuItemId = _ref.activeMenuItemId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var currentPoint = points[currentPointIndex];
  var currentPointNumber = (_currentPoint$point = currentPoint === null || currentPoint === void 0 ? void 0 : currentPoint.point) !== null && _currentPoint$point !== void 0 ? _currentPoint$point : currentPointIndex + 1;
  var isLastPoint = currentPointIndex === points.length - 1;
  var totalPoints = points.length || 2;
  var stepContent = useMemo(function () {
    return getMediastinalContentForPointPhase(currentPointIndex, currentPhase, t);
  }, [currentPointIndex, currentPhase, t]);
  var calculateOverallProgress = useCallback(function () {
    var stepsPerPoint = 2; // transverse + longitudinal
    var completedPoints = currentPointIndex;
    var currentPointSteps = currentPhase === "transverse" ? 0 : 1;
    var totalSteps = completedPoints * stepsPerPoint + currentPointSteps + 1;
    return totalSteps / (totalPoints * stepsPerPoint) * 100;
  }, [currentPointIndex, currentPhase, totalPoints]);
  var stepLabels = points.map(function (p) {
    return String(p.point);
  });
  var pointLabel = getMediastinalPointLabel(currentPointIndex);
  var isCompleteState = isLastPoint && currentPhase === "submit" && !isTransitioning;
  var getButtonLabel = function getButtonLabel() {
    if (isCompleteState) return t("complete", "Complete");
    return t("next", "Next");
  };
  var handleButtonClick = function handleButtonClick() {
    if (isCompleteState) {
      onComplete();
    } else {
      onNext();
    }
  };
  var shouldShowSkip = !isCompleteState;
  return /*#__PURE__*/React.createElement(ScanFlowLayout, {
    title: t("mediastinal_protocol", "Mediastinal Protocol"),
    progress: calculateOverallProgress(),
    steps: stepLabels,
    currentStepIndex: currentPointIndex,
    maxVisible: 8,
    buttonLabel: getButtonLabel(),
    onButtonClick: handleButtonClick,
    showSkip: shouldShowSkip,
    isDisabled: isTransitioning,
    onSkip: onSkip,
    onStepClick: onJumpToPoint,
    isStepDisabled: function isStepDisabled(index) {
      var _points$index, _points$index2;
      return isTransitioning || Boolean(((_points$index = points[index]) === null || _points$index === void 0 ? void 0 : _points$index.transverse) && ((_points$index2 = points[index]) === null || _points$index2 === void 0 ? void 0 : _points$index2.longitudinal));
    },
    isStepComplete: function isStepComplete(index) {
      var _points$index3, _points$index4;
      return Boolean(((_points$index3 = points[index]) === null || _points$index3 === void 0 ? void 0 : _points$index3.transverse) && ((_points$index4 = points[index]) === null || _points$index4 === void 0 ? void 0 : _points$index4.longitudinal));
    },
    onClose: onClose,
    menuItems: menuItems,
    activeMenuItemId: activeMenuItemId
  }, /*#__PURE__*/React.createElement(ZoneIndicator, {
    headerLeft: String(currentPointNumber),
    headerRight: t("mediastinal_point_".concat(currentPointIndex), pointLabel),
    phase: currentPhase,
    content: stepContent,
    slidesConfig: getMediastinalSlidesConfig(currentPointIndex)
  }));
});
MediastinalProtocol.displayName = "MediastinalProtocol";
export default MediastinalProtocol;